import { BrandSliderWrapper, LoadingSkeleton } from '@components';
import { Paper, Stack } from '@mui/material';
import 'swiper/css/bundle';
import { useBrandSlider } from './brand-slider.hook';
type BrandSliderPlaceholderProps = {
  references: number[];
};
export const BrandSliderPlaceholder = ({ references }: BrandSliderPlaceholderProps) => {
  const { dynamicSlidesPerView } = useBrandSlider(references);
  return (
    <BrandSliderWrapper>
      <Stack gap={2} direction='row'>
        {Array.from({ length: dynamicSlidesPerView }).map((_, index) => (
          <Paper sx={{ my: 4, p: 2, width: '100%' }} key={index}>
            <LoadingSkeleton height={140} />
          </Paper>
        ))}
      </Stack>
    </BrandSliderWrapper>
  );
};
